
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"28","height":"28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M0 4a4 4 0 014-4h20a4 4 0 014 4v20a4 4 0 01-4 4H4a4 4 0 01-4-4V4z","fill":"#FEF0C7"}}),_c('g',{attrs:{"clip-path":"url(#clip0_11948_5047)"}},[_c('path',{attrs:{"d":"M14.664 9.417c0 .958.78 1.736 1.74 1.736h3.754v10.143c0 .576-.465 1.042-1.043 1.042H8.878a1.044 1.044 0 01-1.044-1.042V6.713c0-.576.467-1.042 1.044-1.042h5.787v3.746zm1.832 5.197a1.117 1.117 0 00-1.002.524h-.044l-.136-.457h-.784v5.088h.963v-1.433a9.13 9.13 0 00-.05-.512h.05a1.172 1.172 0 00.977.452c.257.006.51-.069.72-.216a1.38 1.38 0 00.474-.634c.117-.315.172-.648.165-.983a2.236 2.236 0 00-.353-1.343 1.147 1.147 0 00-.98-.486zm-4.815-1.021h-1.348v4.618h.98v-1.773h.521v.001l1.103 1.774 1.087-.001c-.211-.303-.664-.974-1.36-2.013.254-.104.474-.277.636-.498.15-.212.228-.466.225-.726a1.228 1.228 0 00-.45-1.04 2.305 2.305 0 00-1.394-.342zm4.5 1.792a.547.547 0 01.502.26c.122.242.177.511.161.782 0 .712-.216 1.068-.648 1.068a.605.605 0 01-.535-.247 1.484 1.484 0 01-.169-.816v-.101.002a1.265 1.265 0 01.17-.726h.002a.606.606 0 01.517-.222zm-4.572-.988c.242-.016.483.031.7.139a.511.511 0 01.226.468.547.547 0 01-.22.485 1.208 1.208 0 01-.686.155h-.316v-1.247h.296zm3.735-8.63c.274.121.081-.015 4.482 4.386.09.09.16.195.212.306h-3.652a1.04 1.04 0 01-1.042-1.042v-3.65z","fill":"#FF9D0B"}})]),_c('defs',[_c('clipPath',{attrs:{"id":"clip0_11948_5047"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(4 4)","d":"M0 0h20v20H0z"}})])])])
          )
        }
      }
    